<template>
  <div class="doby">
    <div class="header">
      <img class="img col-xs-1" src="../../assets/img/logo_blanco[27].png" />
    </div>

    <div class="row">
      <div class="col-2"></div>
      <div class="col-8">
        <div v-if="!tramiteEnviado" class="card ">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h5 class="card-title">Folio: {{ folio }}</h5>
              </div>
    
              <div class="form-group col-3 tablet-sm-3">
                <h6 class="card-title">Propuesta:</h6>
                <select name="" class="form-control" v-model="propuesta">
                  <option value="2">Aceptar</option>
                  <option value="3">Rechazo</option>
                </select>
              </div>
              <div class="col-3">
                <h6 class="ml-1">Fecha: {{date}}</h6>
              </div>
              <div class="col-12">
                <p class="title mt-3 mb-4">{{sComentarios}}</p>
              </div>
              <div class="col-12">
                <h6 class="card-title">Por favor ingresa tus comentarios:</h6>
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  v-model="comentarios"
                  required></textarea>
              </div>
            </div>
            <button
              @click="EstatusTramite"
              class="btn btn-primary--custom m-4 float-right">
              Enviar
            </button>
          </div>
        </div>
        <div v-if="tramiteEnviado" class="card" >
            <div class="card-body text-center">
              <div class="col-12 mt-4 mb-4">
                <h1 class="text-center text-succes">
                  <svg  xmlns="http://www.w3.org/2000/svg" width="160" height="100" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                  </svg>
                </h1>
                  <h3 class="card-title text-center mt-4">Gracias por enviar tus comentarios.</h3>
              </div>
            </div>
          </div>
      </div>
      <div class="col-2"></div>
    </div>
      <loading></loading>
  </div>
</template>

<script>
import Loading from '../../componentes/ImgLoading/loading.vue';
export default {
  components: {
    Loading
  },
  data() {
    return {
      propuesta: "",
      comentarios: "",
      token: this.$route.params.token,
      idCtrlSolicitud: "",
      folio: "",
      date:"",
      sComentarios: "",
      idAcepta: "",
      idRechazo: "",
      idProceso: "",
      tramiteEnviado: false,
      cargar: true,
    };
  },
  methods: {
    
    async ValidarToken() {
      var config = {
        metodo: "VALIDATOKENRUTA",
        data: `sToken=${this.token}`,
      };

      this.$store.dispatch("metodoPost", config).then(() => {
        const res = this.$store.getters.getRespuestaREST;
        if (res.flag) {
          
          this.idCtrlSolicitud = res.data.idCtrlSolicitud;
          this.folio = res.data.Folio;
          this.sComentarios = res.data.sComentariosRH
          this.idAcepta = res.data.idEstatusAcepta
          this.idRechazo = res.data.idEstatusRechaza
          this.idProceso = res.data.idProceso
        }
        else{
          window.location.href = `${location.origin}/#/pages/app/errorToken`;
        }
      });

    },
    async EstatusTramite() {
      if (this.propuesta == "" || this.comentarios == "") {
        this.$swal("Error", "Todos los campos son obligatorios");
      }
      else {
        const payload = {
          metodo: "ESTATUSTRAMITE",
          data: {
            idCtrlSolicitud: this.idCtrlSolicitud,
            Folio: this.folio,
            idCatAccion: this.propuesta.toString(),
            idEstatus: this.propuesta === "2" ? this.idAcepta : this.idRechazo,
            idProceso: this.idProceso,
            sComentarios: this.comentarios,
          },
        };
        try {
          const response = await this.$store.dispatch("metodoPost", payload);
          if (response) {
            const res = this.$store.getters.getRespuestaREST;
            this.$swal({
              icon: "success",
              title: "Comentarios enviados exitosamente",
              showConfirmButton: false,
              timer: 2200,
            });
            this.tramiteEnviado = true;
            this.comentarios = ""
            this.propuesta = 0
          } else {
            this.$swal({
              icon: "error",
              title: "Hubo un error al enviar los comentarios.",
              showConfirmButton: false,
              timer: 2200,
            });
          }
        } catch (error) {
          console.log(error);
        }
       }
    },
    printDate() {
      const fecha = new Date();
      const añoActual = fecha.getFullYear();
      const hoy = fecha.getDate();
      const mesActual = fecha.getMonth() + 1;
      this.date = hoy +"/"+ mesActual+"/"+ añoActual
    },

  },
  mounted() {
    this.ValidarToken();
    this.printDate();
  },
};
</script>
<style>
.header {
  background-color: #003873;
  height: 150px;
}
.img {
  height: 120px;
  margin-left: 25px;
  margin-top: 15px;
}
.card {
  /* width: 55rem; */
  height: 90%;
  margin: 30px;
  border-radius: 25px;
}
textarea {
  height: 150px;
}
.title {
  color: gray;
}




.fulfilling-bouncing-circle-spinner, .fulfilling-bouncing-circle-spinner * {
      box-sizing: border-box;
    }

    .fulfilling-bouncing-circle-spinner {
      height: 60px;
      width: 60px;
      position: relative;
      animation: fulfilling-bouncing-circle-spinner-animation infinite 4000ms ease;
    }

    .fulfilling-bouncing-circle-spinner .orbit {
      height: 60px;
      width: 60px;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 50%;
      border: calc(60px * 0.03) solid #ff1d5e;
      animation: fulfilling-bouncing-circle-spinner-orbit-animation infinite 4000ms ease;
    }

    .fulfilling-bouncing-circle-spinner .circle {
      height: 60px;
      width: 60px;
      color: #ff1d5e;
      display: block;
      border-radius: 50%;
      position: relative;
      border: calc(60px * 0.1) solid #ff1d5e;
      animation: fulfilling-bouncing-circle-spinner-circle-animation infinite 4000ms ease;
      transform: rotate(0deg) scale(1);
    }

    @keyframes fulfilling-bouncing-circle-spinner-animation {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes fulfilling-bouncing-circle-spinner-orbit-animation {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1);
      }
      62.5% {
        transform: scale(0.8);
      }
      75% {
        transform: scale(1);
      }
      87.5% {
        transform: scale(0.8);
      }
      100% {
        transform: scale(1);
      }
    }

    @keyframes fulfilling-bouncing-circle-spinner-circle-animation {
      0% {
        transform: scale(1);
        border-color: transparent;
        border-top-color: inherit;
      }
      16.7% {
        border-color: transparent;
        border-top-color: initial;
        border-right-color: initial;
      }
      33.4% {
        border-color: transparent;
        border-top-color: inherit;
        border-right-color: inherit;
        border-bottom-color: inherit;
      }
      50% {
        border-color: inherit;
        transform: scale(1);
      }
      62.5% {
        border-color: inherit;
        transform: scale(1.4);
      }
      75% {
        border-color: inherit;
        transform: scale(1);
        opacity: 1;
      }
      87.5% {
        border-color: inherit;
        transform: scale(1.4);
      }
      100% {
        border-color: transparent;
        border-top-color: inherit;
        transform: scale(1);
      }
    }
</style>
